import { useEffect } from "react";

interface MetadataProps {
    title: string,
    description: string;
    keywords?: string;
}
function Metadata({ title, description, keywords }: MetadataProps): React.JSX.Element {
    useEffect(() => {
        document.title = title;
    });

    return (
         <>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
        </>
    );
}

export default Metadata;